const accountContainer = document.querySelector('.account__container')
const tabList = document.querySelector('.account__container .js-tablist')

// Password Reset
/*
  The Password Reset popup needs to have a position of absolute and when it would open, it would cover part of the footer.
  So this script adds margin-bottom to the page container, which pushes the footer down, when the PW Reset popup opens.
*/
const pwResetClickhandler = () => {
  tabList.style.display = 'none'
}
const cancelPwResetClickHandler = () => {
  tabList.style.display = 'flex'
}

const pwResetBtn = document.querySelector(
  '#customer_login .account__button--pw-reset'
)
pwResetBtn.addEventListener('click', () => pwResetClickhandler())

const cancelPwResetBtn = document.querySelector(
  '#recover .account__button--cancel-pw-reset'
)
cancelPwResetBtn.addEventListener('click', () => cancelPwResetClickHandler())
